<template>
  <div class="color--editor">
    <perfect-scrollbar class="scrollBody">
      <div class="body">
        <Teleport to="#tooltips">
          <Tooltip :top="-4" :pointer="true" :width="customWidthTooltip" class="fs-12 text-center" />
        </Teleport>
        <div class="content">
          <div class="label mt-1">Brand Color</div>
          <div class="brand-color">
            <div class="group">
              <ColorItem
                v-tooltip.top="getTooltip(colorType.brand2, currentPresetOptions[0].value.brand.color2)"
                :is-active="isCurrentChangeColor(colorType.brand2)"
                :color="currentPresetOptions[0].value.brand.color2"
                :is-can-change-color="true"
                @click="onShowColorPicker('brand', colorType.brand2, 'brand')" />
            </div>
          </div>
          <div class="label mt-1">Other Colors</div>
          <div class="accent-color">
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.neutral1, currentPresetOptions[0].value.neutral.color1)"
              :is-active="isCurrentChangeColor(colorType.neutral1)"
              :color="currentPresetOptions[0].value.neutral.color1"
              :is-can-change-color="true"
              @click="onShowColorPicker('neutral', colorType.neutral1, 'other1')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.neutral2, currentPresetOptions[0].value.neutral.color2)"
              :is-active="isCurrentChangeColor(colorType.neutral2)"
              :color="currentPresetOptions[0].value.neutral.color2"
              :is-can-change-color="true"
              @click="onShowColorPicker('neutral', colorType.neutral2, 'other1')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.neutral3, currentPresetOptions[0].value.neutral.color3)"
              :is-active="isCurrentChangeColor(colorType.neutral3)"
              :color="currentPresetOptions[0].value.neutral.color3"
              :is-can-change-color="true"
              @click="onShowColorPicker('neutral', colorType.neutral3, 'other1')" />

            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.accent1, currentPresetOptions[0].value.accent.color1)"
              :is-active="isCurrentChangeColor(colorType.accent1)"
              :color="currentPresetOptions[0].value.accent.color1"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent1, 'other1')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.accent2, currentPresetOptions[0].value.accent.color2)"
              :is-active="isCurrentChangeColor(colorType.accent2)"
              :color="currentPresetOptions[0].value.accent.color2"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent2, 'other1')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.accent3, currentPresetOptions[0].value.accent.color3)"
              :is-active="isCurrentChangeColor(colorType.accent3)"
              :color="currentPresetOptions[0].value.accent.color3"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent3, 'other1')" />

            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.brand1, currentPresetOptions[0].value.brand.color1)"
              :is-active="isCurrentChangeColor(colorType.brand1)"
              :color="currentPresetOptions[0].value.brand.color1"
              :is-can-change-color="true"
              @click="onShowColorPicker('brand', colorType.brand1, 'other2')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.brand3, currentPresetOptions[0].value.brand.color3)"
              :is-active="isCurrentChangeColor(colorType.brand3)"
              :color="currentPresetOptions[0].value.brand.color3"
              :is-can-change-color="true"
              @click="onShowColorPicker('brand', colorType.brand3, 'other2')" />
            <ColorItem
              v-popover:tooltip.top="getTooltip(colorType.accent7, currentPresetOptions[0].value.accent.color7)"
              :is-active="isCurrentChangeColor(colorType.accent7)"
              :color="currentPresetOptions[0].value.accent.color7"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent7, 'other2')" />

            <ColorItem
              :key="keyUpdateAccentColor4"
              v-popover:tooltip.top="getTooltip(colorType.accent4, currentPresetOptions[0].value.accent.color4)"
              :is-active="isCurrentChangeColor(colorType.accent4)"
              :color="currentPresetOptions[0].value.accent.color4"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent4, 'other2')" />
            <ColorItem
              :key="keyUpdateAccentColor5"
              v-popover:tooltip.top="getTooltip(colorType.accent5, currentPresetOptions[0].value.accent.color5)"
              :is-active="isCurrentChangeColor(colorType.accent5)"
              :color="currentPresetOptions[0].value.accent.color5"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent5, 'other2')" />
            <ColorItem
              :key="keyUpdateAccentColor6"
              v-popover:tooltip.top="getTooltip(colorType.accent6, currentPresetOptions[0].value.accent.color6)"
              :is-active="isCurrentChangeColor(colorType.accent6)"
              :color="currentPresetOptions[0].value.accent.color6"
              :is-can-change-color="true"
              @click="onShowColorPicker('accent', colorType.accent6, 'other2')" />
          </div>
        </div>
        <div v-if="showColorPicker" class="color--picker" :style="styleColorPicker">
          <GfColorPicker
            :key="`${targetPicker}-${targetType}`"
            :color="selectedColor"
            @out-size="colorOutSize"
            @cancel="onCancel"
            @apply="onApply"
            @change-color="onApply" />
        </div>
        <div>
          <div class="sidebar--section" @click="showSuggestColor = !showSuggestColor">
            <div class="suggest--label">Suggested Color Palettes</div>
            <i :class="['icon icon-chevron-up icon-up', { 'transform-y': !showSuggestColor }]" />
          </div>
          <div v-show="showSuggestColor" class="suggest-palettes">
            <div
              v-for="palette in suggestColors"
              :key="palette.key"
              class="palette"
              @click="suggestColor(palette.value)">
              <div
                v-for="(color, ind) in palette.value.slice(0, 5)"
                :key="color"
                class="palette--color"
                :class="{ 'border-1': ind === 0, 'border-2': ind === 4 }"
                :style="{ background: color }"></div>
            </div>
          </div>
        </div>
      </div>
      <GuideCustomizeStyle
        v-if="!obGlobalStyle.tooltipColorStyle"
        title="Setup Color"
        guide="tooltipColorStyle"
        content="Color will be applied to your pages, you can always adjust this later."
        link="https://help.gempages.net/articles/customize-global-style#table-content-0" />
    </perfect-scrollbar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HELPER from '@/app/utils/HELPER';
import GfColorPicker from '@/core/components/base/GfColorPicker.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import { actions, mutations } from '@modules/editor-sidebar';
import { presetOptionTypes, colorType } from '../../constants/styleConstant';
import { cloneDeep } from '@/utils/common';
import GuideCustomizeStyle from '../guide/GuideCustomizeStyle.vue';
import emitter from '@/emitter';
import ColorItem from '@/core/components/base/color/ColorItem.vue';

interface DataInterface {
  colorType: any;
  positionColorPicker: {
    brand: string;
    other1: string;
    other2: string;
  };
  targetPicker: string;
  targetType: string;
  targetColor: string;
  mouseover: string;
  showColorPicker: boolean;
  showSuggestColor: boolean;
  customWidthTooltip: string;
  neutralBaseColor: string;
  brandBaseColor: string;
  isReadyToSave: boolean;
  paletteColor: any;
  logCloseColorPicker: boolean;
  selectedColor: any;
  COLOR_TOOLTIP: any;
  activeBorderColor: string;
  targetPositionColorPicker: string;
  keyUpdateAccentColor4: number;
  keyUpdateAccentColor5: number;
  keyUpdateAccentColor6: number;
}

interface ColorPickerData {
  hex: string;
  hsv: {
    h: number;
    s: number;
    v: number;
  };
  rgba: {
    a: number;
    b: number;
    g: number;
    r: number;
  };
}

// New tooltip for new design
const COLOR_TOOLTIP: any = {
  brand_2: 'Brand Color',
  neutral_1: 'Color 1',
  neutral_2: 'Color 2',
  neutral_3: 'Color 3',
  accent_1: 'Color 4',
  accent_2: 'Color 5',
  accent_3: 'Color 6',
  brand_1: 'Color 7',
  brand_3: 'Color 8',
  accent_7: 'Color 9',
  accent_4: 'Color 10',
  accent_5: 'Color 11',
  accent_6: 'Color 12',
};

export default defineComponent({
  name: 'Color',
  components: {
    GfColorPicker,
    GuideCustomizeStyle,
    ColorItem,
  },
  data: (): DataInterface => ({
    colorType: colorType,
    positionColorPicker: {
      brand: '105px',
      other1: '205px',
      other2: '248px',
    },
    targetPicker: '',
    targetType: '',
    targetColor: '',
    mouseover: '',
    showColorPicker: false,
    showSuggestColor: true,
    customWidthTooltip: 'auto',
    neutralBaseColor: '',
    brandBaseColor: '',
    isReadyToSave: true,
    logCloseColorPicker: false,
    paletteColor: {
      neutral: '#848484',
      brand: '#f3633a',
      brand2: '#592e83',
      brand3: '#05a8aa',
      brand4: '#0b2b2c',
      brand5: '#d8aa59',
      brand6: '#d6068d',
      brand7: '#ffc8d6',
      brand8: '#092164',
    },
    selectedColor: '',
    COLOR_TOOLTIP,
    activeBorderColor: '#3C67FF',
    targetPositionColorPicker: '',
    keyUpdateAccentColor4: Math.random(),
    keyUpdateAccentColor5: Math.random(),
    keyUpdateAccentColor6: Math.random(),
  }),
  computed: {
    ...mapState('sidebar', {
      currentPreset: (state) => (state as any).currentPreset,
      currentPresetOptions: (state) => (state as any).currentPresetOptions,
    }),
    ...mapState('app', {
      shopMeta: 'shopMeta',
    }),
    obGlobalStyle() {
      return this.shopMeta.onboardingGlobalStyle;
    },
    suggestColors() {
      return [
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand),
            this.brand2(this.paletteColor.brand),
            this.brand3(this.paletteColor.brand),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand),
            this.accent2(this.paletteColor.brand),
            this.accent3(this.paletteColor.brand),
          ],
          key: 1,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand2),
            this.brand2(this.paletteColor.brand2),
            this.brand3(this.paletteColor.brand2),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand2),
            this.accent2(this.paletteColor.brand2),
            this.accent3(this.paletteColor.brand2),
          ],
          key: 2,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand3),
            this.brand2(this.paletteColor.brand3),
            this.brand3(this.paletteColor.brand3),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand3),
            this.accent2(this.paletteColor.brand3),
            this.accent3(this.paletteColor.brand3),
          ],
          key: 3,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand4),
            this.brand2(this.paletteColor.brand4),
            this.brand3(this.paletteColor.brand4),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand4),
            this.accent2(this.paletteColor.brand4),
            this.accent3(this.paletteColor.brand4),
          ],
          key: 4,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand5),
            this.brand2(this.paletteColor.brand5),
            this.brand3(this.paletteColor.brand5),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand5),
            this.accent2(this.paletteColor.brand5),
            this.accent3(this.paletteColor.brand5),
          ],
          key: 5,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand6),
            this.brand2(this.paletteColor.brand6),
            this.brand3(this.paletteColor.brand6),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand6),
            this.accent2(this.paletteColor.brand6),
            this.accent3(this.paletteColor.brand6),
          ],
          key: 6,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand7),
            this.brand2(this.paletteColor.brand7),
            this.brand3(this.paletteColor.brand7),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand7),
            this.accent2(this.paletteColor.brand7),
            this.accent3(this.paletteColor.brand7),
          ],
          key: 7,
        },
        {
          value: [
            this.neutral1(this.paletteColor.neutral),
            this.brand1(this.paletteColor.brand8),
            this.brand2(this.paletteColor.brand8),
            this.brand3(this.paletteColor.brand8),
            this.neutral3(this.paletteColor.neutral),

            this.accent1(this.paletteColor.brand8),
            this.accent2(this.paletteColor.brand8),
            this.accent3(this.paletteColor.brand8),
          ],
          key: 8,
        },
      ];
    },
    styleColorPicker() {
      if (this.targetPositionColorPicker === 'brand') {
        return {
          top: this.positionColorPicker.brand,
        };
      } else if (this.targetPositionColorPicker === 'other1') {
        return {
          top: this.positionColorPicker.other1,
        };
      } else {
        return {
          top: this.positionColorPicker.other2,
        };
      }
    },
  },
  created() {
    this.setPresetTypeId(presetOptionTypes.color);
    const presetColors = this.currentPreset.presetOptions.colors;
    this.setCurrentPresetOptions(cloneDeep(presetColors));
    this.neutralBaseColor = presetColors[0].value.neutral.color2;
    this.brandBaseColor = presetColors[0].value.brand.color2;

    emitter.on?.('cancelColor', (colors: any) => {
      this.neutralBaseColor = colors[0].value.neutral.color2;
      this.brandBaseColor = colors[0].value.brand.color1;
    });
  },
  methods: {
    ...mapActions('sidebar', {
      savePresetOptions: actions.SAVE_PRESET_OPTIONS,
    }),
    ...mapMutations('sidebar', {
      setPresetTypeId: mutations.SET_PRESET_TYPE_ID,
      setCurrentPresetOptions: mutations.SET_CURRENT_PRESET_OPTIONS,
    }),
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    neutral1(neutralBase: string) {
      return this.$tinycolor.mix(neutralBase, 'white', 90).toHex8String();
    },
    neutral2(neutralBase: string) {
      return this.$tinycolor(neutralBase).toHex8String();
    },
    neutral3(neutralBase: string) {
      return this.$tinycolor.mix(neutralBase, 'black', 85).toHex8String();
    },
    brand1(brandBase: string) {
      return this.$tinycolor.mix(brandBase, 'white', 30).toHex8String();
    },
    brand2(brandBase: string) {
      return this.$tinycolor(brandBase).toHex8String();
    },
    brand3(brandBase: string) {
      return this.$tinycolor.mix(brandBase, 'black', 25).toHex8String();
    },
    accent2(brandBase: string) {
      return this.$tinycolor(brandBase).isDark()
        ? this.complement(brandBase).lighten(20).toHex8String()
        : this.complement(brandBase).toHex8String();
    },
    accent1(brandBase: string) {
      return this.$tinycolor(this.accent2(brandBase)).analogous(6, 30)[1].lighten(10).toHex8String();
    },
    accent3(brandBase: string) {
      return this.$tinycolor(this.accent2(brandBase)).analogous(6, 30)[5].darken(30).toHex8String();
    },
    complement(brandBase: string) {
      return this.$tinycolor(brandBase).complement();
    },
    cancel() {
      this.$emit('cancel');
    },
    onHover(key: string) {
      this.mouseover = key;
      if (key == this.colorType.brand2) {
        this.customWidthTooltip = '88px';
      }
    },
    onLeave() {
      this.mouseover = '';
      this.customWidthTooltip = 'auto';
    },
    colorOutSize() {
      if (!this.logCloseColorPicker) {
        this.showColorPicker = false;
      }
    },
    onCancel() {
      this.showColorPicker = false;
    },
    onApply(color: ColorPickerData) {
      this.handlePickColor(color);
    },
    suggestColor(colors: Array<string>) {
      const colorValue = this.currentPresetOptions[0].value;
      this.brandBaseColor = colors[2];
      colorValue.neutral.color1 = colors[0];
      colorValue.brand.color1 = colors[1];
      colorValue.brand.color2 = colors[2];
      colorValue.brand.color3 = colors[3];
      colorValue.neutral.color3 = colors[4];

      colorValue.accent.color1 = colors[5];
      colorValue.accent.color2 = colors[6];
      colorValue.accent.color3 = colors[7];
    },
    getBackgroundOpacity(color: string) {
      return color;
    },
    onShowColorPicker(type: string, target: string, targetPosition: string) {
      this.showColorPicker = true;
      this.logCloseColorPicker = true;
      this.targetType = type;
      this.targetPicker = target;
      this.targetPositionColorPicker = targetPosition;

      switch (this.targetPicker) {
        case colorType.neutralBase:
          this.selectedColor = this.neutralBaseColor;
          break;
        case colorType.neutral1:
          this.selectedColor = this.currentPresetOptions[0].value.neutral.color1;
          break;
        case colorType.neutral2:
          this.selectedColor = this.currentPresetOptions[0].value.neutral.color2;
          break;
        case colorType.neutral3:
          this.selectedColor = this.currentPresetOptions[0].value.neutral.color3;
          break;
        case colorType.brandBase:
          this.selectedColor = this.brandBaseColor;
          break;
        case colorType.brand1:
          this.selectedColor = this.currentPresetOptions[0].value.brand.color1;
          break;
        case colorType.brand2:
          this.selectedColor = this.currentPresetOptions[0].value.brand.color2;
          break;
        case colorType.brand3:
          this.selectedColor = this.currentPresetOptions[0].value.brand.color3;
          break;
        case colorType.accent1:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color1;
          break;
        case colorType.accent2:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color2;
          break;
        case colorType.accent3:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color3;
          break;
        case colorType.accent4:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color4;
          break;
        case colorType.accent5:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color5;
          break;
        case colorType.accent6:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color6;
          break;
        case colorType.accent7:
          this.selectedColor = this.currentPresetOptions[0].value.accent.color7;
          break;
        default:
          break;
      }

      setTimeout(() => {
        this.logCloseColorPicker = false;
      });
    },
    handlePickColor(color: ColorPickerData) {
      const hex = HELPER.rgbToFullHex(color.rgba);

      switch (this.targetPicker) {
        case colorType.neutralBase:
          this.neutralBaseColor = hex;
          this.currentPresetOptions[0].value.neutral.color1 = this.neutral1(hex);
          this.currentPresetOptions[0].value.neutral.color2 = this.neutral2(hex);
          this.currentPresetOptions[0].value.neutral.color3 = this.neutral3(hex);
          break;
        case colorType.neutral1:
          this.currentPresetOptions[0].value.neutral.color1 = hex;
          break;
        case colorType.neutral2:
          this.currentPresetOptions[0].value.neutral.color2 = this.neutral2(hex);
          this.neutralBaseColor = this.neutral2(hex);
          break;
        case colorType.neutral3:
          this.currentPresetOptions[0].value.neutral.color3 = hex;
          break;
        case colorType.brandBase:
          this.brandBaseColor = this.brand2(hex);
          this.currentPresetOptions[0].value.brand.color1 = this.brand1(hex);
          this.currentPresetOptions[0].value.brand.color2 = this.brand2(hex);
          this.currentPresetOptions[0].value.brand.color3 = this.brand3(hex);

          this.currentPresetOptions[0].value.accent.color1 = this.accent1(hex);
          this.currentPresetOptions[0].value.accent.color2 = this.accent2(hex);
          this.currentPresetOptions[0].value.accent.color3 = this.accent3(hex);
          break;
        case colorType.brand1:
          this.currentPresetOptions[0].value.brand.color1 = hex;
          break;
        case colorType.brand2:
          this.currentPresetOptions[0].value.brand.color2 = this.brand2(hex);
          break;
        case colorType.brand3:
          this.currentPresetOptions[0].value.brand.color3 = hex;
          break;
        case colorType.accent1:
          this.currentPresetOptions[0].value.accent.color1 = hex;
          break;
        case colorType.accent2:
          this.currentPresetOptions[0].value.accent.color2 = hex;
          break;
        case colorType.accent3:
          this.currentPresetOptions[0].value.accent.color3 = hex;
          break;
        case colorType.accent4:
          this.currentPresetOptions[0].value.accent.color4 = hex;
          this.keyUpdateAccentColor4++;
          break;
        case colorType.accent5:
          this.currentPresetOptions[0].value.accent.color5 = hex;
          this.keyUpdateAccentColor5++;
          break;
        case colorType.accent6:
          this.currentPresetOptions[0].value.accent.color6 = hex;
          this.keyUpdateAccentColor6++;
          break;
        case colorType.accent7:
          this.currentPresetOptions[0].value.accent.color7 = hex;
          break;
        default:
          break;
      }
    },
    isHexColor(hex: string) {
      return /^#([0-9a-f]{3}){1,2}$/i.test(hex);
    },
    getBackgroundColorLinear(type: string) {
      switch (type) {
        case colorType.neutral1:
          return this.currentPresetOptions[0].value.neutral.color1;
        case colorType.neutral3:
          return this.currentPresetOptions[0].value.neutral.color3;
        case colorType.brand1:
          return this.currentPresetOptions[0].value.brand.color1;
        case colorType.brand3:
          return this.currentPresetOptions[0].value.brand.color3;
      }
    },
    getBorderColor(color: any) {
      return this.$tinycolor(color).isDark()
        ? this.$tinycolor.mix(color, 'white', 30).toHex8String()
        : this.$tinycolor.mix(color, 'black', 30).toHex8String();
    },
    getTooltip(type: any, val: any) {
      if (val) {
        return COLOR_TOOLTIP[type];
      }
      return 'Add New Color';
    },
    isCurrentChangeColor(type: any) {
      return this.showColorPicker && this.targetPicker === type;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.border-1 {
  border-radius: 4px 0 0 4px;
}

.border-2 {
  border-radius: 0 4px 4px 0;
}

.default-border {
  border: 1px solid rgba(50, 50, 50, 0.48) !important;
}

.opacity-0_5 {
  opacity: 0.5;
}

.scrollBody {
  height: calc(100%);
  display: flex;
  flex-direction: column;

  .body {
    flex: 1;
  }
}

.color--picker {
  position: absolute;
  top: 17%;
  left: 8px;
  margin-left: 12px;
  margin-right: 21px;
  z-index: 10;
}

.transform-y {
  transform: scaleY(-1);
}

.sidebar--section {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  height: 24px;
  align-items: center;
  margin: 16px 0;

  .suggest--label {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: map-get($text-dark-mode, 'low-contrast');
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .icon-up {
    font-size: 12px;
    margin-right: 6px;
  }
}

.suggest-palettes {
  display: flex;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-left: -8px;

  .palette {
    flex: 0 0 calc(50% - 16px);
    max-width: calc(50% - 16px);
    margin-right: 8px;
    margin-left: 8px;
    border-radius: 4px;
    display: flex;
    margin-bottom: 16px;
    cursor: pointer;
    border: 1px solid map-get($hybrid-shade-dark, '100');

    .palette--color {
      width: 25%;
      height: 50px;
      border: none;
    }
  }
}

.accent-color {
  display: flex;
  flex-wrap: wrap;
  margin-left: 3px;
  padding-bottom: 8px;

  @media only screen and (max-width: 1300px) {
    margin-left: 5px;
  }

  .box {
    @include flex-center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    margin: 0 3px;
    cursor: pointer;
    background-image: url('/editor/static/icons/bg-transparent.svg');
  }

  &--wrapper {
    background: map-get($hybrid-shade-dark, '200');
    border: 1px dashed map-get($hybrid-shade-light, '500');
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
  }
}

.label {
  padding-left: 8px;
  padding-bottom: 16px;
  padding-top: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: map-get($text-dark-mode, 'high-contrast');
}

.body {
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 16px;
}

.color--editor {
  flex: none;
  order: 0;
  flex-grow: 0;
  position: relative;
  height: calc(100% - 125px);

  .content {
    background: map-get($hybrid-shade-dark, '300');
    border-radius: 3px;
  }

  .list__neutral-color {
    display: flex;
    width: 100%;
    background-image: url('/editor/static/icons/bg-transparent.svg');
    border-radius: 6px;
  }

  .list__brand-color {
    display: flex;
    width: 100%;
    background-image: url('/editor/static/icons/bg-transparent.svg');
    border-radius: 6px;
  }

  .group {
    display: flex;
    align-items: center;
    padding-left: 3px;
    padding-right: 8px;

    @media only screen and (max-width: 1300px) {
      padding-left: 5px;
    }
  }

  .base-color {
    background-image: url('/editor/static/icons/bg-transparent.svg');
    border-radius: 6px;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 4px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    @include flex-center;

    &--box {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .color {
    flex: 0 0 33.333333%;
    height: 32px;
    cursor: pointer;
    @include flex-center;

    &.hover {
      background: rgba(0, 0, 0, 0.5);
    }
  }
  .fs-12 {
    font-size: 12px;
  }
}
</style>
